import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=28f4f534&scoped=true&"
import script from "./question.ts?vue&type=script&lang=ts&"
export * from "./question.ts?vue&type=script&lang=ts&"
import style0 from "./Question.vue?vue&type=style&index=0&id=28f4f534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4f534",
  null
  
)

export default component.exports